import React, {
  useCallback,
  useMemo,
  useState,
} from 'react';
import analytics from '../../../../modules/analytics';
import { IProviderClient } from '../../../../api/Providers/Clients/types';
import { ProClientAdd } from '../ProClientAdd';

const ITERATION_KEY = 'add-upload-secure-012018';

/**
 * Returns a tuple with [<component to render>, <action trigger>, <callback]
 */
type UseAddClientResult = {
  Component: React.ComponentType;
  handler: () => void;
};

export function useAddClientHandler(
  source?: string,
  onNewClientSaved?: (newClient: IProviderClient) => void,
): UseAddClientResult {
  const [isAddClientOpen, setAddClientOpen] = useState<boolean>(false);

  const handleAddClientClick = useCallback(() => {
    const params = {
      pro_add_clients_method: 'add-client-button',
      pro_add_client_source: ITERATION_KEY,
      source: source || 'Client Empty State',
    };
    analytics.track('P Clicked Add New Client', params);
    setAddClientOpen(true);
  }, [source]);

  const handleAddClientSave = useCallback((newClient: IProviderClient) => {
    onNewClientSaved?.(newClient);
    setAddClientOpen(false);
  }, [onNewClientSaved]);

  const handleAddClientClose = useCallback(() => {
    setAddClientOpen(false);
  }, []);

  const { Component } = useMemo(() => ({
    Component: () => (isAddClientOpen ? (
      <ProClientAdd
        onSave={handleAddClientSave}
        onClose={handleAddClientClose}
      />
    ) : null),
  }), [
    isAddClientOpen,
    handleAddClientClose,
    handleAddClientSave,
  ]);

  return {
    Component,
    handler: handleAddClientClick,
  };
}
